import {Model} from "ords/dist/model/model"

export class RubricRow extends  Model{
    hasAnswerForColumn(columnId, user_id) {
        if(this.answers){
            for(const answer of this.answers){
                if(answer.column_id === columnId && answer.row_id === this.id){
                    if (user_id) {
                        if (answer.user_id === user_id) {
                            return true;
                        }
                    } else {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    rowHasAnswer(){
        return !!this.answers.length;
    }

    hasAnswerForOtherUsers(user_id) {
        return this.answers.some((answer) => answer.user_id !== user_id);
    }

    colorByUser(user_id, answer){
        if(answer.user.id === user_id){
            return 'current-graph-bg-color';
        }

        switch (answer.user.type){
            case 'teacher':
                return 'teacher-graph-bg-color';
            case 'student':
                return 'student-peer-graph-bg-color';
            default:
                return 'default-peer-graph-bg-color';
        }
    }

    hasAnswerForOtherUsersForColumn(user_id, column_id) {
        return this.answers.some((answer) => answer.user_id !== user_id && answer.column_id === column_id);
    }

    getAnswersForOtherUsersForColumn(user_id, column_id) {
        return this.answers.filter((answer) => answer.user_id !== user_id && answer.column_id === column_id)
    }


    hasCellDescription(column) {
        for(const cell of column.rubric_cells){
            if(cell.row_id === this.id) {
                return true;
            }
        }
    }

    getCellDescription(column) {
        for(const cell of column.rubric_cells){
            if(cell.row_id === this.id){
                 return cell.value;
            }
        }
    }
}

export const RubricRowConfig = {
    name: 'rubricRow',
    model: RubricRow,
    relations: [
        {name: 'rubric_cells', model_name: 'rubricCell', type: 'hasMany'},
        {name: 'answers', model_name:'rubricAnswer', type: 'hasMany'},
    ]
}
